import { Browser } from '@capacitor/browser';
import { registerPlugin } from '@capacitor/core';

import { IS_NATIVE } from '../../../../common/constants';

const PRIVACY_NOTICE_PDF_URL_BY_LANGUAGE: Record<string, string> = {
  'en-US': 'https://d1ujsszxcydv12.cloudfront.net/schneider_charge_privacy_notice_en-US.pdf',
  'en-CA': 'https://d1ujsszxcydv12.cloudfront.net/schneider_charge_privacy_notice_en-CA.pdf',
  'es-US': 'https://d1ujsszxcydv12.cloudfront.net/schneider_charge_privacy_notice_es-US.pdf',
  'fr-CA': 'https://d1ujsszxcydv12.cloudfront.net/schneider_charge_privacy_notice_fr-CA.pdf',
};

const DEFAULT_PRIVACY_NOTICE_PDF_URL = PRIVACY_NOTICE_PDF_URL_BY_LANGUAGE['en-US'];

interface NativePdfViewerPlugin {
  open(params: { url: string; title?: string }): Promise<void>;
}

const NativePdfViewer = registerPlugin<NativePdfViewerPlugin>('NativePdfViewer');

function getPrivacyNoticePdfUrl(language: string): string {
  return PRIVACY_NOTICE_PDF_URL_BY_LANGUAGE[language] ?? DEFAULT_PRIVACY_NOTICE_PDF_URL;
}

export async function openPrivacyNoticePdfInWebView(language: string): Promise<void> {
  const pdfUrl = getPrivacyNoticePdfUrl(language);

  if (IS_NATIVE) {
    try {
      await NativePdfViewer.open({ url: pdfUrl, title: 'Privacy Notice' });
      return;
    } catch (error) {
      const code =
        typeof error === 'object' && error !== null && 'code' in error
          ? String((error as { code?: unknown }).code)
          : '';
      if (code !== 'UNIMPLEMENTED') {
        throw error;
      }
    }
  }

  await Browser.open({ url: pdfUrl });
}
